import { Card, Empty, Form, Input, message, notification } from "antd";
import { useForm } from "antd/es/form/Form";
import React, { useCallback, useEffect, useState } from "react";
import DataTable from "./dataTable";
import { API } from "../../config/Api";
import { GET, POST } from "../../utils/apiRequest";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import PageHeaders from "../../components/pageHeaders";
import Loading from "../../components/loading";

function Commission() {
  const navigate = useNavigate();
  const [form] = useForm();
  const [page, setPage] = useState(1);
  const [take, setTake] = useState(10);
  const [cardsData, setCardsData] = useState<any[]>([]);
  const [cardDetails, setCardDetails] = useState<any[]>([]);
  const [meta, setMeta] = useState<any>(null);
  const [isLoadingCards, setIsLoadingCards] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [Notifications, contextHolder] = notification.useNotification();

  const getAllCards = useCallback(
    async (currentPage: number = 1, itemsPerPage: number = 10) => {
      try {
        setIsLoadingCards(true);
        const response: any = await POST(API.REFERENCE_CARDS, {
          page: currentPage,
          take: itemsPerPage,
        });
        if (response?.status) {
          setCardsData(response.data);
          setMeta(response.meta);
        } else {
          setCardsData([]);
        }
      } catch (error) {
        console.error("Failed to fetch cards:", error);
        setCardsData([]);
        Notifications.error({ message: "Failed to load cards" });
      } finally {
        setIsLoadingCards(false);
      }
    },
    []
  );

  const getCardDetails = useCallback(async (cardNo: string) => {
    try {
      setIsLoadingDetails(true);
      const response: any = await GET(`${API.CARDS_FULL_DETAILS}${cardNo}`);
      if (response?.data?.length) {
        setCardDetails(response.data);
        message.success("Card details found");
      } else {
        setCardDetails([]);
        message.error("Card not found");
      }
    } catch (error) {
      console.error("Failed to fetch card details:", error);
      setCardDetails([]);
      message.error("Network error");
    } finally {
      setIsLoadingDetails(false);
    }
  }, []);

  useEffect(() => {
    getAllCards(page, take);
  }, [page, take, getAllCards]);

  const handlePageChange = (newPage: number, newTake: number) => {
    setPage(newPage);
    setTake(newTake);
  };

  const handleSearch = (value: string) => {
    if (value) {
      getCardDetails(value);
    } else {
      // When input is cleared, load all cards
      setCardDetails([]);
      getAllCards(page, take);
    }
  };

  return (
    <div>
      {contextHolder}
      <PageHeaders title="Commission" backButton={true}>
        <Form form={form}>
          <Row>
            <Col md={8}>
              <Form.Item name="cardNo">
                <Input
                  placeholder="Card No"
                  allowClear
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </PageHeaders>
      <div className="screenBox">
        <Card>
          {isLoadingCards || isLoadingDetails ? (
            <Loading />
          ) : cardsData.length || cardDetails.length ? (
            <DataTable
              page={page}
              take={take}
              data={cardDetails.length ? cardDetails : cardsData}
              loading={isLoadingCards || isLoadingDetails}
              onChange={handlePageChange}
              onView={(item: any) =>
                navigate(`/Auth/CommissionDetails/${item.id}`, {
                  state: { val: item },
                })
              }
            />
          ) : (
            <Empty />
          )}
        </Card>
      </div>
    </div>
  );
}

export default Commission;

// import { Button, Card, Empty, Form, Input, message, notification } from "antd";
// import { useForm } from "antd/es/form/Form";
// import React, { useCallback, useEffect, useState } from "react";
// import DataTable from "./dataTable";
// import { CiSearch } from "react-icons/ci";
// import { API } from "../../config/Api";
// import { GET, POST } from "../../utils/apiRequest";
// import { Col, Row } from "react-bootstrap";
// import NoData from "../components/noData";
// import { useNavigate } from "react-router-dom";
// import PageHeaders from "../../components/pageHeaders";
// import Loading from "../../components/loading";

// function Commission() {
//   const navigate = useNavigate();
//   const [form] = useForm();
//   const [page, setPage] = useState(1);
//   const [take, setTake] = useState(10);
//   const [cardsData, setCardsData] = useState<any[]>([]); // Replace 'any' with proper Card type
//   const [cardDetails, setCardDetails] = useState<any[]>([]); // Replace 'any' with proper type
//   const [meta, setMeta] = useState<any>(null); // Define meta type
//   const [isLoadingCards, setIsLoadingCards] = useState(false);
//   const [isLoadingDetails, setIsLoadingDetails] = useState(false);
//   const [Notifications, contextHolder] = notification.useNotification();

//   // Memoize to prevent unnecessary re-renders
//   const getAllCards = useCallback(
//     async (currentPage: number = 1, itemsPerPage: number = 10) => {
//       try {
//         setIsLoadingCards(true);
//         const response: any = await POST(API.REFERENCE_CARDS, {
//           page: currentPage,
//           take: itemsPerPage,
//         });
//         if (response?.status) {
//           setCardsData(response.data);
//           setMeta(response.meta);
//         } else {
//           setCardsData([]);
//         }
//       } catch (error) {
//         console.error("Failed to fetch cards:", error);
//         setCardsData([]);
//         Notifications.error({ message: "Failed to load cards" });
//       } finally {
//         setIsLoadingCards(false);
//       }
//     },
//     []
//   );

//   const getCardDetails = useCallback(async (cardNo: string) => {
//     try {
//       setIsLoadingDetails(true);
//       const response: any = await GET(`${API.CARDS_FULL_DETAILS}${cardNo}`);
//       if (response?.data?.length) {
//         setCardDetails(response.data);
//         message.success("Card details found");
//       } else {
//         setCardDetails([]);
//         message.error("Card not found");
//       }
//     } catch (error) {
//       console.error("Failed to fetch card details:", error);
//       setCardDetails([]);
//       message.error("Network error");
//     } finally {
//       setIsLoadingDetails(false);
//     }
//   }, []);

//   useEffect(() => {
//     getAllCards(page, take);
//   }, [page, take, getAllCards]);

//   const handlePageChange = (newPage: number, newTake: number) => {
//     setPage(newPage);
//     setTake(newTake);
//   };

//   const onSubmit = (values: { cardNo: string }) => {
//     getCardDetails(values.cardNo);
//   };

//   return (
//     <div>
//       {contextHolder}
//       <PageHeaders title="Commission" backButton={true}>
//         <Form onFinish={onSubmit}>
//           <Row>
//             <Col md={8}>
//               <Form.Item name="cardNo">
//                 <Input
//                   placeholder="Card No"
//                   allowClear
//                   onChange={() => onSubmit(form.getFieldsValue())}
//                 />
//               </Form.Item>
//             </Col>
//             {/* <Col md={4}>
//               <Button type="primary" htmlType="submit" block>
//                 Search
//               </Button>
//             </Col> */}
//           </Row>
//         </Form>
//       </PageHeaders>
//       <div className="screenBox">
//         <Card>
//           {isLoadingCards || isLoadingDetails ? (
//             <Loading />
//           ) : cardsData.length || cardDetails.length ? (
//             <DataTable
//               page={page}
//               take={take}
//               data={cardDetails.length ? cardDetails : cardsData}
//               loading={isLoadingCards || isLoadingDetails}
//               onChange={handlePageChange}
//               onView={(item: any) =>
//                 navigate(`/Auth/CommissionDetails/${item.id}`, {
//                   state: { val: item },
//                 })
//               }
//             />
//           ) : (
//             <Empty />
//           )}
//         </Card>
//       </div>
//     </div>
//   );
// }

// export default Commission;

// function Commission() {
//   const navigate = useNavigate();
//   const [form] = useForm();
//   const [Notifications, contextHolder] = notification.useNotification();

//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoading2, setIsLoading2] = useState(false);

//   const [data, setData] = useState([]);
//   const [summary, setSummary] = useState({ totalAmount: 0 });

//   const [meta, setMeta] = useState<any>({});
//   const [page, setPage] = useState<number>(1);
//   const [take, setTake] = useState<number>(10);

//   useEffect(() => {
//     getAllCards();
//   }, []);

//   const onChange = async (page: number, take: number) => {
//     setPage(page);
//     setTake(take);
//     await getAllCards(page, take);
//   };

//   const getAllCards = async (page: number = 1, take: number = 10) => {
//     try {
//       setIsLoading2(true);
//       let obj = { page, take };
//       let api = API.REFERENCE_CARDS;
//       const result: any = await POST(api, obj);
//       if (result?.status) {
//         setData(result?.data);
//         setMeta(result?.meta);
//         setIsLoading2(false);
//       } else {
//         setIsLoading2(false);
//         setData([]);
//       }
//     } catch (error) {
//       setIsLoading2(false);
//       console.log(error);
//       Notifications["error"]({
//         message: "Network error",
//       });
//     }
//   };

//   const getData = async (value: any) => {
//     setIsLoading(true);
//     try {
//       let api = API.CARDS_FULL_DETAILS + value?.cardNo;
//       const response: any = await GET(api);
//       if (response?.data?.length) {
//         setData(response?.data);
//         setIsLoading(false);
//         Notifications["success"]({
//           message: "Data Found",
//         });
//       } else {
//         setIsLoading(false);
//         Notifications["error"]({
//           message: "Data Not Found",
//         });
//         setData([]);
//       }
//     } catch (err) {
//       console.log(err);
//       setIsLoading(false);
//       Notifications["error"]({
//         message: "Network error",
//       });
//     }
//   };

//   const onView = (val: any) => {
//     navigate(`/Auth/CommissionDetails/${val?.id}`, { state: { val } });
//   };

//   return (
//     <div>
//       {contextHolder}
//       <PageHeaders title={"Commission"} backButton={true}>
//         <Form form={form}
//         onFinish={getData}
//         >
//           <div className="jobScreen-PageHeaderBox">
//             <Row>
//               <Col md="8">
//                 <Form.Item name={"cardNo"} noStyle>
//                   <Input
//                     style={{ width: "100%" }}
//                     placeholder="Card No"
//                     allowClear
//                   />
//                 </Form.Item>
//               </Col>
//               <Col md="4">
//                 <Form.Item>
//                   <Button
//                     type="primary"
//                     htmlType="submit"
//                     style={{ width: "100%" }}
//                   >
//                     Search
//                   </Button>
//                 </Form.Item>
//               </Col>
//             </Row>
//           </div>
//         </Form>
//       </PageHeaders>
//       <div className="screenBox">
//         <Card>
//           {isLoading ? (
//             <Loading />
//           ) : data?.length ? (
//             <DataTable
//               page={page}
//               take={take}
//               data={data}
//               loading={isLoading}
//               summary={summary}
//               onChange={onChange}
//               onView={(item: any) => onView(item)}
//             />
//           ) : (
//             <Empty />
//           )}
//         </Card>
//       </div>
//     </div>
//   );
// }

// export default Commission;
